import ClienteCreate from './ClienteCreate.vue'

export default ClienteCreate
